import cn from 'classnames';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import IconButton from 'components/ui/Button/IconButton';
import { GlassesIcon } from 'components/ui/icons/GlassesIcon';
import { useRem } from 'hooks/useRem';
import { accessibilityParamsStore } from 'stores/root';

import s from './AccessibilityButton.module.scss';

type Props = {
  className?: string;
};

const AccessibilityButton: React.FC<Props> = ({ className }) => {
  const { isOpen: isAccessibilityMode } = accessibilityParamsStore;
  const calcRem = useRem();

  return (
    <IconButton
      className={cn(s.root, isAccessibilityMode && s.root_accessibility, className)}
      Icon={GlassesIcon}
      iconSize={calcRem({ desktop: 48 })}
      onClick={accessibilityParamsStore.toggle}
    />
  );
};

export default observer(AccessibilityButton);
